export const REQUEST_PRODUCTS = 'zola/overview/REQUEST_PRODUCTS';
export const REQUEST_ADDITIONAL_PRODUCTS = 'zola/overview/REQUEST_ADDITIONAL_PRODUCTS';
export const RECEIVE_PRODUCTS = 'zola/overview/RECEIVE_PRODUCTS';
export const RECEIVE_ADDITIONAL_PRODUCTS = 'zola/overview/RECEIVE_ADDITIONAL_PRODUCTS';

export const REQUEST_CHECKLIST = 'zola/checklist/REQUEST_CHECKLIST';
export const RECEIVE_CHECKLIST = 'zola/checklist/RECEIVE_CHECKLIST';



// WEBPACK FOOTER //
// ./src/actions/types/RegistryOverviewActionTypes.js